import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import { useFormik } from "formik";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from '../Global';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const SeasonEdit = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [backendErrors, setBackendErrors] = useState([]);
 

  useEffect(() => {
    axios
      .get(`/settings-seasons/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.season);

        }
       
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const {
    values,
  
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      id: value.id,
      name: value.name,
      start: value.start,
      end: value.end,
    },
    enableReinitialize: true,
    onSubmit: (values, actions) => { 
         axios
        .post("/settings-seasons/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          $("#form-submit").text("Update season");
          delete backendErrors['error'];
          actions.setSubmitting(false);
          if (response.data.code === 200) {
            toast.success(response.data.message);
            actions.resetForm();
            setTimeout(() => {
              window.location.href = "/seasons";
            }, 500);
          }
            else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
         
        })
        .catch((error) => {
          console.log(error)
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

const customHandleInput = (event) => {
  const Input_name = event.target.name;
  delete backendErrors[Input_name];
};


  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /><ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Season Edit</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/seasons">Season</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Term Information </h4>
                    <form action="#" onSubmit={handleSubmit}>
                    
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label> Name</label>
                            <input
                              type="text"
                              name="name"
                              value={values.name}
                              className= "form-input form-control"
                           
                              onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              }}
                               onBlur={handleBlur}
                               placeholder="Enter Season Name"
                            />
                           <small>
                              {backendErrors.name && (
                                <span className="form-error mt-1">
                                  {backendErrors.name}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        
                        <div className="col-md-3">
                          <div className="form-group">
                            <label> Start Date</label>
                           
                                <div className="input-group">
                                <input 
                                   type="date"
                                  
                                  name="start"
                                  value={values.start}
                                  onChange={(e) => {
                                    handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={handleBlur}
                                  className="form-control" placeholder="Start Date" />
                              </div>


                           <small>
                              {backendErrors.start && (
                                <span className="form-error mt-1">
                                  {backendErrors.start}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label> End</label>
                             <div className="input-group">
                                  <input 
                                   type="date"
                                  
                                  name="end"
                                  value={values.end}
                                  onChange={(e) => {
                                    handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={handleBlur}
                                  className="form-control" placeholder="End Date" />
                                 
                              </div>
                           <small>
                              {backendErrors.end && (
                                <span className="form-error mt-1">
                                  {backendErrors.end}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        
                   
                        
                    
                       
                      </div>

                        <small>
                              {backendErrors.status  && (
                                <span className="form-error mt-1">
                                  {backendErrors.status}
                                </span>
                              )}

                          
                            </small>
                             <div className="text-end mt-4">
                                <button
                                  type="submit" id="form-submit"
                                  className="btn btn-primary"
                                  disabled={isSubmitting}
                                >
                                  Update Season
                                </button>
                              </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SeasonEdit;
